import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <h3 className="text-2xl font-bold mb-4">Lunexa</h3>
            <p className="text-gray-300 mb-4">
              Leading the future with innovative IT solutions, automation, and AI-powered services.
            </p>
            <div className="flex space-x-4">
              <a href="https://linkedin.com/company/lunexa" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white">
                LinkedIn
              </a>
              <a href="https://twitter.com/lunexa" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white">
                Twitter
              </a>
              <a href="https://github.com/lunexa" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white">
                GitHub
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Company</h4>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-gray-300 hover:text-white">About Us</Link></li>
              <li><Link to="/services" className="text-gray-300 hover:text-white">Services</Link></li>
              <li><Link to="/products" className="text-gray-300 hover:text-white">Products</Link></li>
              <li><Link to="/careers" className="text-gray-300 hover:text-white">Careers</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Legal</h4>
            <ul className="space-y-2">
              <li><Link to="/privacy" className="text-gray-300 hover:text-white">Privacy Policy</Link></li>
              <li><Link to="/terms" className="text-gray-300 hover:text-white">Terms of Service</Link></li>
              <li><Link to="/refund" className="text-gray-300 hover:text-white">Refund Policy</Link></li>
              <li><Link to="/contact" className="text-gray-300 hover:text-white">Contact</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-gray-700">
          <p className="text-center text-gray-300">
            © 2024 Lunexa. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;